module.exports = __webpack_public_path__ + "img/logo.6ff9f7f4.svg";